import Vue from "vue";
import ExportDialogContent from "./AppointmentsExportDialogContent.vue";
export default Vue.extend({
    data() {
        return {
            animationSettings: { effect: "None" },
            contentTemplate: function () {
                return {
                    template: ExportDialogContent
                };
            }
        };
    },
    methods: {
        show() {
            // The content resets the filters before the dialog is shown
            this.$emit("show");
            this.$refs.appointmentsExportDialog.show();
        },
        hide() {
            this.$refs.appointmentsExportDialog.hide();
        }
    }
});
